import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import style from '../ScheduleForm/ScheduleForm.scss';

const ExpressInterestStepContainer = ({ title, subtitle, content, active=false, expressed=false }) => {
  const schoolNameButtonClasses = ['button--no-style', style.scheduleFormStepButton];
  if (expressed) {
    schoolNameButtonClasses.push(style.scheduleFormStepButtonDone);
  }

  let icon = 'icon-Check';
  if (active) {
    icon = 'icon-Pencil';
  }
  let titleHTML = <div>{title}</div>;
  if (active) {
    titleHTML = <h2 className={style.scheduleFormStepTitleActive}>{title}</h2>;
  }
  return (
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepTitleContainer}>
        <button disabled aria-label={title} className={classNames(...schoolNameButtonClasses)}>
          <div className={style.scheduleFormStepButtonIcon}>
            <i className={icon} />
          </div>
          <div className={style.scheduleFormStepTitle}>
            {titleHTML}
            <div>{subtitle}</div>
          </div>
        </button>
      </div>
      {content}
    </div>
  );
};
ExpressInterestStepContainer.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.element,
  content: PropTypes.element,
  active: PropTypes.bool,
  expressed: PropTypes.bool,
};

export default ExpressInterestStepContainer;
